import React, { useLayoutEffect, useRef, useState } from 'react'
import { Link } from '@mui/material'

import { STORE_RELATIONS_SECONDARY_USERS_TOGGLE_LABELS } from '../../constants/storeConstants'

const StoreRelationBrandsCell = ({ rowKey, brands = [] }) => {
  const [expanded, setExpanded] = useState(false)
  const [hasOverflow, setHasOverflow] = useState(false)
  const chipsRef = useRef(null)

  useLayoutEffect(() => {
    const element = chipsRef.current
    if (!element) return

    const checkOverflow = () => {
      setHasOverflow(element.scrollHeight > element.clientHeight + 1)
    }

    checkOverflow()

    if (typeof ResizeObserver === 'undefined') return undefined

    const resizeObserver = new ResizeObserver(checkOverflow)
    resizeObserver.observe(element)

    return () => resizeObserver.disconnect()
  }, [brands, expanded])

  return (
    <div className="store-relations-brand-cell-wrap">
      <div
        ref={chipsRef}
        className={`store-relations-brand-chip-list ${expanded ? 'store-relations-brand-chip-list--expanded' : ''}`}
      >
        {brands.map((brand, index) => (
          <span key={`${rowKey}-${brand}-${index}`} className="store-relations-brand-chip">
            {brand}
          </span>
        ))}
      </div>

      {(hasOverflow || expanded) && (
        <Link
          component="button"
          type="button"
          className="store-relations-brand-toggle"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded
            ? STORE_RELATIONS_SECONDARY_USERS_TOGGLE_LABELS.COLLAPSE
            : STORE_RELATIONS_SECONDARY_USERS_TOGGLE_LABELS.EXPAND}
        </Link>
      )}
    </div>
  )
}

export default StoreRelationBrandsCell
